import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AreaSuperior, ColunaTabela, LinhaTabela, OpcoesFiltragem, SecaoAdmin, SecaoPrincipal, Tabela } from "../AdminStyled";
import MenuLateral from "../../../componentes/MenuLateral";
import ModalPergunta from "../../../componentes/ModalPergunta";
import CabecalhoAdmin from "../../../componentes/CabecalhoAdmin";
import Titulo1 from "../../../componentes/Titulo1";
import Botao from "../../../componentes/Botao";
import ErroSpan from "../../../componentes/ErroSpan";
import ModalObservacao from "../../../componentes/ModalObservacao";
import { cancelarCupom, marcarCupomUtilizado, obterCupomPorId } from "../../../servicos/cuponsServices";

export default function CupomId(){
    const { id } = useParams();
    const [cupom, setCupom] = useState(null);
    const [perguntaUtilizar, setPerguntaUtilizar] = useState(false);
    const [perguntaJustificativa, setPerguntaJustificativa] = useState(false);
    const [justificativa, setJustificativa] = useState("");
    const [status, setStatus] = useState({ mostrar: false, erro: false, mensagem: "" });

    // Busca o cupom ao carregar a página
    useEffect( () => {
        obterCupomPorId(id).then( resposta => {
            // Verifica se encontrou cupom e aplica
            if (resposta) setCupom(resposta);
        });
    }, [id]);

    const handleSim = async () => {
        marcarCupomUtilizado(cupom).then(res => {
            if (res) {
                setStatus({ mostrar: true, erro: false, mensagem: "Cupom marcado como utilizado" });
                obterCupomPorId(id).then( resposta => {
                    // Verifica se encontrou cupom e aplica
                    if (resposta) setCupom(resposta);
                });
            } else {
                setStatus({ mostrar: true, erro: true, mensagem: "Erro ao marcar cupom como utilizado" });
            }
        })
        setPerguntaUtilizar(false);
    };
    const handleNao = async () => {
        setPerguntaUtilizar(false);
    };

    const handleConfirma = () => {
        if (justificativa) {
            cancelarCupom(cupom, justificativa).then( res => {
                if (res) {
                    setStatus({ mostrar: true, erro: false, mensagem: "Cupom cancelado com sucesso." });
                    setJustificativa("");
                    obterCupomPorId(id).then( resposta => {
                        // Verifica se encontrou cupom e aplica
                        if (resposta) setCupom(resposta);
                    });
                } else {
                    setStatus({ mostrar: true, erro: true, mensagem: "Erro ao cancelar cupom." });
                }
            })
            setPerguntaJustificativa(false);
        }
    };
    const handleCancela = () => {
        setPerguntaJustificativa(false);
    };

    return (<SecaoAdmin>
        <MenuLateral />
        <SecaoPrincipal>
            {CabecalhoAdmin("Visualizar cupom")}
            {ModalPergunta("Tem certeza que deseja marcar este cupom como utilizado?", handleSim, handleNao, perguntaUtilizar, "100px")}
            {ModalObservacao("Informe uma justificativa", perguntaJustificativa, handleConfirma, handleCancela, "130px", "500px", justificativa, setJustificativa)}
            {status.mostrar && <ErroSpan $corFundo={status.erro? "#ffcdcd": "#ddffcd"} $corTexto={status.erro? "#9e0000": "#209e00"}>{status.mensagem}</ErroSpan>}
            {cupom && <>
            <AreaSuperior>
                <Titulo1>Código {cupom.codigo}</Titulo1>
                <OpcoesFiltragem>
                    {!cupom.jaUtilizado && !cupom.cancelado && <Botao $marginRight="10px" onClick={() => setPerguntaUtilizar(true)}>Utilizar</Botao>}
                    {!cupom.jaUtilizado && !cupom.cancelado && <Botao $cor="#ff2424" onClick={() => setPerguntaJustificativa(true)}>Cancelar cupom</Botao>}
                </OpcoesFiltragem>
            </AreaSuperior>
            <Tabela>
                <LinhaTabela>
                    <ColunaTabela $cor="#252525" $tamanho="200px">Data criação</ColunaTabela>
                    <ColunaTabela>{<p style={{margin: 0}}>{formatarData(new Date(cupom.dataCriacao)) || "-"}</p>}</ColunaTabela>
                </LinhaTabela>
                <LinhaTabela>
                    <ColunaTabela $cor="#252525" $tamanho="200px">Visitante</ColunaTabela>
                    <ColunaTabela><Link style={{ textDecoration: 'none', color: "inherit" }} to={`/admin/visitantes/${cupom.visitante._id}`}>{cupom.visitante.nome || cupom.visitante.email || cupom.visitante.celular || "-"}</Link></ColunaTabela>
                </LinhaTabela>
                <LinhaTabela>
                    <ColunaTabela $cor="#252525" $tamanho="200px">Origem</ColunaTabela>
                    <ColunaTabela>{<p style={{margin: 0}}>{cupom.origem || "-"}</p>}</ColunaTabela>
                </LinhaTabela> 
                <LinhaTabela>
                    <ColunaTabela $cor="#252525" $tamanho="200px">Utilizado</ColunaTabela>
                    <ColunaTabela>{<p style={{margin: 0}}>{cupom.jaUtilizado? `Cupom utilizado em ${formatarData(new Date(cupom.dataUtilizacao))}` :"Não" }</p>}</ColunaTabela>
                </LinhaTabela>
                <LinhaTabela>
                    <ColunaTabela $cor="#252525" $tamanho="200px">Versão</ColunaTabela>
                    <ColunaTabela>{<p style={{margin: 0}}>{cupom.versao || "-"}</p>}</ColunaTabela>
                </LinhaTabela>
            </Tabela>
            {cupom.cancelado && <p style={ {marginLeft: "60px"}}>{`Este cupom foi cancelado! Motivo: ${cupom.motivoCancelamento}`}</p>}
            </>}
        </SecaoPrincipal>
    </SecaoAdmin>)
}

function formatarData(date) {
    const dia = String(date.getDate()).padStart(2, "0");
    const mes = String(date.getMonth() + 1).padStart(2, "0");
    const ano = date.getFullYear();

    const hora = String(date.getHours()).padStart(2, "0");
    const minuto = String(date.getMinutes()).padStart(2, "0");
    const segundo = String(date.getSeconds()).padStart(2, "0");

    return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
}